export function PearLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13.4 7.2c.35-1.2.2-2.5 1.3-3.4.5-.4 1.3-.5 1.4.2.15.9-.5 1.7-1.3 2.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.2c-3 0-5.2 2.4-5.2 5.6 0 3.4 2 6.9 5.2 6.9s5.2-3.5 5.2-6.9c0-3.2-2.2-5.6-5.2-5.6Z"
        fill="currentColor"
        opacity="0.15"
      />
      <path
        d="M12 7.2c-3 0-5.2 2.4-5.2 5.6 0 3.4 2 6.9 5.2 6.9s5.2-3.5 5.2-6.9c0-3.2-2.2-5.6-5.2-5.6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
